<template>
  <section v-on="$listeners" class="app-section">
    <slot />
  </section>
</template>

<script>
export default {
  name: 'AppSection',
}
</script>

<style lang="scss" scoped>
.app-section {
  width: 100%;
}
</style>
